export enum LookupType {
  salutation = 'SALUTATIONS',
  countryIso3Code = 'CTRYISONUM3',
  contactAttribute = 'CONTACTATTRIBUTE',
  province = 'IRLPROVINCE',
  cities = 'IRLCITY',
  baseStationTypes = 'BR_APPLICATION_BASESTATIONTYPE',
  channelDirection = 'CHANNELDIRECTION',
  polarity = 'POLARITY',
  transmissionType = 'TRANSMISSIONTYPE',
  methodOfOperation = 'METHODOFOPERATION',
  toneControlType = 'TONECONTROLTYPE',
  areaOfOperation = 'AREAOFOPERATIONTYPE',
  knownLocationType = 'KNWLOCTYPE',
  prsNotificationType = 'PRS_NOTIFICATIONTYPE',
}
